"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const useCopyTextElement_1 = tslib_1.__importDefault(require("./useCopyTextElement"));
const CopyTextElement = (props) => {
    const hook = (0, useCopyTextElement_1.default)();
    return ((0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: hook.copied ? 'დაკოპირდა' : null, children: (0, jsx_runtime_1.jsx)("i", { className: 'text-primary icon-md far fa-copy pointer p-2', onClick: () => hook.copyTextElement(props.values) }) }));
};
exports.default = CopyTextElement;
